import { GraphBuilder } from '../graph/builder';
import { ComponentDef } from './types';

export const mambaComponent: ComponentDef = {
  id: 'mamba',
  name: 'Mamba Block',
  description: 'Structured state-space sequence model block with selective scan and input-dependent gating.',
  category: 'component',
  params: [
    { name: 'd_model', label: 'Model dimension', type: 'number', default: 512, min: 64, max: 4096, step: 64 },
    { name: 'seq_len', label: 'Sequence length', type: 'number', default: 128, min: 1, max: 8192, step: 1 },
    { name: 'state_dim', label: 'SSM state dimension', type: 'number', default: 16, min: 1, max: 256, step: 1 },
    {
      name: 'variant',
      label: 'Algorithm variant',
      type: 'select',
      default: 'mamba1',
      options: [
        { label: 'Mamba-1 (conv1d + SSM)', value: 'mamba1' },
        { label: 'Mamba-2 (SSD)', value: 'mamba2' }
      ]
    }
  ],
  buildGraph: (params) => {
    const d_model = Number(params.d_model);
    const seq_len = Number(params.seq_len);
    const state_dim = Number(params.state_dim);
    const d_inner = d_model * 2;
    const delta_rank = 16;
    const variant = String(params.variant || 'mamba1');

    const g = new GraphBuilder();
    g.input('x', [seq_len, d_model]);
    g.linear('in_proj', 'x', [d_model, d_inner * 2]);
    g.gate('z', 'in_proj', [seq_len, d_inner]);

    if (variant === 'mamba2') {
      // Mamba-2: Structured State Space Duality (SSD) — no depthwise conv, uses grouped SSM
      g.linear('x_proj', 'in_proj', [d_inner * 2, delta_rank + state_dim * 2]);
      g.selectiveScan('ssd', 'in_proj', [seq_len, d_inner]);
      g.mul('gated', 'z', 'ssd');
    } else {
      // Mamba-1: depthwise conv1d before SSM, causal context mixing
      g.conv('conv1d', 'in_proj', [seq_len, d_inner], 'depthwise k=4');
      g.activation('conv_act', 'conv1d', 'SiLU');
      g.linear('x_proj', 'conv_act', [d_inner, delta_rank + state_dim * 2]);
      g.selectiveScan('ssm', 'conv_act', [seq_len, d_inner]);
      g.mul('gated', 'z', 'ssm');
    }

    g.linear('out_proj', 'gated', [d_inner, d_model]);
    g.output('out', 'out_proj');
    return g.build();
  }
};
